var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserveOnline24 = function SvgReserveOnline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.473 12.346 6.788 17.25 1.5 11.727l5.807-6.086A3.668 3.668 0 0 1 9.952 4.5c.991 0 1.942.41 2.645 1.141.41.428.72.95.903 1.523",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 10.144a1.754 1.754 0 1 1 1.155-2.11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.884 9.173a2.625 2.625 0 0 1-.184-.201l-.066-.08a3.17 3.17 0 0 1-.68-1.971m1.296-2.288a3.087 3.087 0 0 1 1.223-.735 3.131 3.131 0 0 1 2.756.426c.392.28.712.646.933 1.07a2.976 2.976 0 0 1 .007 2.738 3.035 3.035 0 0 1-.927 1.074 3.107 3.107 0 0 1-1.323.544",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.613 12.75a2.642 2.642 0 0 1-.594-.476 2.857 2.857 0 0 1-.719-1.432 2.967 2.967 0 0 1 .15-1.616 2.77 2.77 0 0 1 .967-1.255 2.511 2.511 0 0 1 1.458-.471c.52 0 1.027.164 1.458.471.432.307.768.744.967 1.255.199.511.25 1.073.15 1.616a2.857 2.857 0 0 1-.719 1.431 2.7 2.7 0 0 1-.594.477m-.137 0v6.785L13.626 21 12 19.535v-1.251l1.12-1.087-1.12-.64 1.252-1.23L12 14.829l.002-2.079m-6.752-1.5v1.5h3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.361A7.003 7.003 0 0 1 9 15m3.75-9.21a6.989 6.989 0 0 1 2.701-.54h.11c.143 0 .287 0 .428.018a7.054 7.054 0 0 1 4.724 2.37 7.16 7.16 0 0 1 1.782 5.006 7.152 7.152 0 0 1-2.154 4.855 7.045 7.045 0 0 1-4.89 2.001",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.75h-3V18m0-6h3.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReserveOnline24;